// Time-related utility functions used across the app

export function formatDateForApi(date) {
  // Return a date string in ISO-like 'en-CA' format (YYYY-MM-DD) using local timezone
  if (date instanceof Date) {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Berlin';
    return new Intl.DateTimeFormat('en-CA', { timeZone: tz }).format(date);
  }
  return date;
}

  export  const formatDateTime = (isoString) => {
        if (!isoString) return "Nicht aktiviert";
        const date = new Date(isoString);
        const dateStr = date.toLocaleDateString('de-DE');
        const timeStr = date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
        return `am ${dateStr} um ${timeStr}`;
    };


export function parseTimeStringToMinutes(timeStr) {
  if (!timeStr) return null;
  const parts = timeStr.split(':').map(Number);
  if (parts.length < 2 || parts.some(isNaN)) return null;
  const [h, m] = parts;
  return h * 60 + m;
}

export function isUnitNow(unit, nowDate = new Date()) {
  if (!unit || !unit.startTime || !unit.endTime) return false;
  try {
    const now = new Date(nowDate);
    const nowMinutes = now.getHours() * 60 + now.getMinutes();

    const startMinutes = parseTimeStringToMinutes(unit.startTime);
    const endMinutes = parseTimeStringToMinutes(unit.endTime);

    if (startMinutes == null || endMinutes == null) return false;

    return nowMinutes >= startMinutes && nowMinutes <= endMinutes;
  } catch (e) {
    return false;
  }
}

export function getCurrentTimeISO() {
  return new Date().toISOString();
}

export function isElementFocusedWithin(ref) {
  return !!(ref && ref.current && ref.current.contains(document.activeElement));
}
